import kebabCase from 'lodash.kebabcase'
import { getFormFieldTranslationId } from '@/helpers/form'
import { i18n } from '@/i18n'
import { ActivityLogParser } from '@/parsers/activityLog'

export class ContractInformationActivityLogParser extends ActivityLogParser {
    static attributeDataTypes = {
        'start_date': 'date',
        'end_date': 'date',
        'premium': 'currency',
        'consulting_mandate_enquiry_send_date': 'date',
    }

    static hideSubjectRelationInLogDescription = true

    static getLogDetailsUpdated (activityLog, data) {
        const details = []

        Object.keys(activityLog.properties.attributes).forEach(attributeKey => {
            // Handle special case for nested product_field_values.
            if (attributeKey === 'product_field_values') {
                const newValue = activityLog.properties.attributes[attributeKey]
                const oldValue = activityLog.properties?.old?.[attributeKey]
                const newProductFields = (this.checkValue(newValue)) ? activityLog.subject.computeProductFields(activityLog.subject.productTemplate.form_configuration, newValue) : null
                const oldProductFields = (this.checkValue(oldValue)) ? activityLog.subject.computeProductFields(activityLog.subject.productTemplate.form_configuration, oldValue) : null

                if (newProductFields && oldProductFields) {
                    Object.keys(newProductFields).forEach(productFieldKey => {
                        const newProductField = newProductFields[productFieldKey]
                        const oldProductField = oldProductFields[productFieldKey]

                        // Only add details if old and new value are different.
                        if (newProductField.rawValue !== oldProductField.rawValue) {
                            const detail = {
                                key: productFieldKey,
                                label: newProductField.label,
                            }
                            const newProductFieldDataType = typeof newProductField.rawValue === 'boolean' ? 'boolean' : 'undefined'
                            const oldProductFieldDataType = typeof oldProductField.rawValue === 'boolean' ? 'boolean' : 'undefined'
                            const newProductFieldDisplayValue = newProductField.formattedValue ?? this.getFormattedLogDetailValue(activityLog, attributeKey, newProductFieldDataType, newProductField.value)
                            const oldProductFieldDisplayValue = oldProductField.formattedValue ?? this.getFormattedLogDetailValue(activityLog, attributeKey, oldProductFieldDataType, oldProductField.value)
                            if (this.checkValue(newProductFieldDisplayValue)) detail.newValue = newProductFieldDisplayValue
                            if (this.checkValue(oldProductFieldDisplayValue)) detail.oldValue = oldProductFieldDisplayValue
                            details.push(detail)
                        }
                    })
                }
            } else {
                const attributeDataType = this.attributeDataTypes[attributeKey] ?? 'undefined'
                const detail = {
                    key: attributeKey,
                    label: i18n.tc(getFormFieldTranslationId({ type: 'label', context: kebabCase(activityLog.log_name), key: kebabCase(attributeKey) }), 1),
                }

                const newValue = activityLog.properties.attributes[attributeKey]
                const oldValue = activityLog.properties?.old?.[attributeKey]

                if (this.checkValue(newValue)) detail.newValue = this.getFormattedLogDetailValue(activityLog, attributeKey, attributeDataType, newValue)
                if (this.checkValue(oldValue)) detail.oldValue = this.getFormattedLogDetailValue(activityLog, attributeKey, attributeDataType, oldValue)

                details.push(detail)
            }
        })

        return this.hideLogDetailsUpdated ? [] : details
    }
}
